<style lang="less" type="text/less" scoped>
    @import '../../styles/common';
    .my-input{
        @h:20px;
        line-height:@h;
        position:relative;
        display:inline-block;
        margin:5px 0;
        width:200px;
        .sign{
            position:absolute;
            color:@colorError;
            right:100%;
            top:0;

        }
        .icon{
            transform:scale(0.9);
        }
        .del{
            position:absolute;
            right:0;
            top:0;
        }
        &.wide{
            display:block;
            width:auto;
            input{
                width:100%;
            }
        }
        &.error{
            input{
                border-bottom-color:@colorError !important;
            }
        }
        .fake-placeholder{
            position:absolute;
            top:0;
            left:0;
            padding:0 5px;
            font-size:14px;
            color:#ccc;
            background:#fff;
            width:100%;
        }
        ::placeholder{
            color:#ccc;
        }
        input{
            appearance: none;
            -webkit-appearance: none;
            background: #fff;
            width:100%;
            border-radius:0px;
            color:#333;
            line-height:@h;
            min-height:@h;
            border:1px solid #ccc;
            padding:0 10px 0 2px;
            box-sizing:border-box;
            font-size:14px;
            box-shadow:none;
            &:focus{
                outline:none;
            }
        }
        .suggestion{
            position:absolute;
            z-index:1;
            top:100%;
            left:0;
            width:100%;
            padding-top:1px;
            ul{
                @lh:50px;
                border:1px solid #ddd;
                background:#f8f8f8;
                padding:0 10px;
                max-height:@lh*4;
                list-style: none;
                &.overflow{
                    overflow-y: scroll; /* has to be scroll, not auto */
                    -webkit-overflow-scrolling: touch;
                }
                li{
                    line-height:@lh;
                    font-size:28px;
                    box-sizing:border-box;
                    border-bottom:1px solid #ddd;
                    &:last-child{
                        border:none;
                    }
                }
            }
        }
        .suggestion-hint{
            position:absolute;
            z-index:1;
            top:100%;
            left:0;
            width:100%;
            padding-top:1px;
            background:#f8f8f8;
            text-align:center;
            color:#ccc;
        }
    }
</style>
<template>
    <div class="my-input" :class="{wide:wide,error:error && error.error}">
        <div class="sign" v-show="required && !noRequiredSign">*</div>
        <div class="del" v-show="focus && val">
            <div class="icon icon-no gray" @click="clear();"></div>
        </div>
        <input ref="input" type="text" v-if="type=='text'" v-model="val" :placeholder="placeholder" :disabled="disabled" @focus="onFocus()" @blur="onBlur()" @keyup.enter="onEnter();">
        <input ref="input" type="date" v-if="type=='date'" v-model="val" :placeholder="placeholder" :disabled="disabled" @focus="onFocus()" @blur="onBlur()">
        <input ref="input" type="datetime-local" v-if="type=='datetime-local'" v-model="val" :placeholder="placeholder" :disabled="disabled" @focus="onFocus()" @blur="onBlur()">
        <input ref="input" type="password" v-if="type=='password'" v-model="val" :placeholder="placeholder" :disabled="disabled" @focus="onFocus()" @blur="onBlur()" @keyup.enter="onEnter();">
        <input ref="input" type="number" v-if="type=='number'" v-model="val" :placeholder="placeholder" @focus="onFocus()" :disabled="disabled" @blur="onBlur()" @keyup.enter="onEnter();">
        <input ref="input" type="tel" v-if="type=='tel'" v-model="val" :placeholder="placeholder" @focus="onFocus()" :disabled="disabled" @blur="onBlur()" @keyup.enter="onEnter();">
        <div class="fake-placeholder" v-if="needFakePlaceholder()" v-show="!val && !focus" @click="clickFakePlaceholder();">{{placeholder}}</div>
        <div class="error-msg" v-show="error && error.error">{{error.msg}}</div>
        <div class="suggestion-hint" v-show="val && !searching && focus && onlyAllowAutoComplete && !(suggestions && suggestions.length)">
            没有搜索结果
        </div>
        <div class="suggestion"  v-show="suggestions && suggestions.length">
            <ul :class="{overflow:suggestions.length>4}">
                <li v-for="(item,index) in suggestions" @click="chooseThisSuggestion(item)" v-bind:key="index">
                    {{item}}
                </li>
            </ul>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">

    var autoCompleteTimeout = null;

    module.exports = {
        props:{
            value:{
                type:String
            },
            type:{
                type:String,
                default:'text'
            },
            placeholder:{
                type:String,
                default:""
            },
            autoCompleter:{
                type:Function,
                default:function (val) {return []}
            },
            onClearWhenNotMatched:{
                type:Function,
                default:function (val) {return []}
            },
            onlyAllowAutoComplete:{
                type:Boolean,
                default:false
            },
            wide:{
                type:Boolean,
                default:false
            },
            disabled:{
                type:Boolean,
                default:false
            },
            error:{
                type:Object,
                default:function(){
                    return {
                        error:false,
                        msg:""
                    };
                }
            },
            validator:{
                type:Function
            },
            required:{
                type:Boolean,
                default:false
            },
            noRequiredSign:{
                type:Boolean,
                default:false
            },
            blurCheck:{
                type:Boolean,
                default:false
            }
        },
        data: function () {
            return {
                focus:false,
                val:"",
                searching:false,
                errorShowed:false,
                suggestionActive:true,
                suggestions:[]
            }
        },
        watch:{
            value:function (val) {
                this.val = val;
            },
            val:function (val) {
                var vm = this;
                this.showSuggestions(val);

                if(this.errorShowed){
                    this.checkValid();
                }
                this.$emit('input',val);
            }
        },
        methods: {
            clear:function () {
                this.val = "";
                this.suggestions = [];
                if(!this.isDateType()){
                    this.$nextTick(function () {
                        $(this.$refs.input).focus();
                    })
                }
            },
            onFocus:function () {
                var vm = this;
                vm.focus = true;
                this.showSuggestions(this.val);
            },
            onEnter:function () {
                this.$emit('keyup-enter');
            },
            onBlur:function () {
                var vm = this;
                setTimeout(function () {
                    if(!$(vm.$refs.input).is(':focus')){
                        if(vm.onlyAllowAutoComplete){
                            vm.checkIfValueInSuggestions();
                        }
                        vm.focus = false;
                        vm.suggestions = [];
                        if(vm.blurCheck){
                            vm.checkValid();
                        }
                    }
                },100)
            },
            needFakePlaceholder:function(){
                return this.isDateType();
            },
            isDateType:function () {
                return [
                            'date',
                            'datetime-local'
                        ].indexOf(this.type) != -1;
            },
            clickFakePlaceholder:function () {
                $(this.$refs.input).click().focus();
            },
            checkIfValueInSuggestions:function(){
                var val = $.trim(this.val);
                if(this.suggestions.indexOf(val) == -1){
                    this.val = "";
                    this.onClearWhenNotMatched();
                }else{
                    this.$emit('chooseSuggestion',val);
                }
            },
            checkValid:function (forceHidden) { // return isValid;
                var val = $.trim(this.val);
                var isError = false;
                var msg = "";

                if(val && this.validator){
                    var r = this.validator(val);
                    if(r!=="" && r!==true){
                        isError = true;
                        msg = r;
                    }
                }

                if(this.required && !val){
                    isError = true;
                    msg = "此项必填";
                }

                isError = forceHidden ? false : isError;

                if(isError){
                    this.errorShowed = true;
                }
                $.extend(this.error,{
                    error:isError,
                    msg:msg
                });
                var isValid = !isError;
                return isValid;
            },
            chooseThisSuggestion:function (val) {
                var vm = this;
                this.suggestionActive = false;
                this.val = val;
                this.$emit('chooseSuggestion',val);
                setTimeout(function () {
                    vm.suggestions = [];
                    vm.suggestionActive = true;
                },200);
            },
            showSuggestions:function (val) {
                var vm = this;
                if(vm.autoCompleteTimeout){
                    clearTimeout(vm.autoCompleteTimeout)
                }
                this.searching = true;
                vm.autoCompleteTimeout = setTimeout(function () {
                    vm.getSuggestions(val);
                },200);
            },
            getSuggestions:function (val) {
                var vm = this;
                this.searching = true;
                if( !$.trim(val) ){
                    this.suggestions = [];
                    this.searching = false;
                }else{
                    if( // allow show suggestion
                            this.focus
                            && this.suggestionActive
                            && this.autoCompleter
                    ){
                        var r = this.autoCompleter(val);
                        if(r && r.then){
                            r.then(function (data) {
                                if(vm.focus){
                                    vm.suggestions = data;
                                }else{
                                    vm.suggestions = [];
                                }
                                vm.fixFocus();
                                vm.searching = false;
                            }).catch(()=>{
                                vm.searching = false;
                            })
                        }else{
                            this.suggestions = r||[];
                            this.searching = false;
                        }
                    }else{
                        this.searching = false;
                    }
                }
            }
        },
        fixFocus(){
            this.$refs.input.blur();
            setTimeout(()=>{
                this.$refs.input.focus();
            },50);
        },
        directives:{
//            preventScroll:require('../prevent-window-scroll.directive.js')
        },
        components: {},
        mounted: function () {
            this.val = this.value;
        }
    }
</script>


// WEBPACK FOOTER //
// Input.vue?da4769c2